export enum CHANNELS_ENUMERATION {
  APP_CHANNEL = 'APP_CHANNEL_RC',
  CLOSE_CHANNEL = 'CLOSE_CHANNEL_RC',
}

export enum CHANNELS_EVENTS_ENUMERATION {
  LOGIN = 'LOGIN',
  HOME = 'HOME',
  PAYMENT_STATUS = 'PAYMENT_STATUS',
}
